var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h3", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("apeironGwApp.datosBeca.title"))),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.convocatoria"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.solucionSolicitud
                                  ?.nombreConvocatoria
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t("apeironGwApp.datosBeca.label.grado"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.apoyo?.tipoApoyo?.descripcion
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.nombrePrograma"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.apoyo?.programa)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t("apeironGwApp.datosBeca.label.pais"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.form.beca?.apoyo?.pais.descripcion)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.institucion"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.apoyo?.institucion?.descripcion
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.estatusBeca"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.estadoActual)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.fechaInicio"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.periodoBeca?.fechaInicioBeca
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.fechaFin"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.form.beca?.periodoBeca?.fechaFinBeca)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-container"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.solicitud.solicitudUri
        ? _c(
            "b-link",
            { attrs: { href: _vm.solicitud.solicitudUri, target: "_blank" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", id: "id-convenio" },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.datosBeca.label.solicitud")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-descargar" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.solicitud.anexo_uno
        ? _c(
            "b-link",
            { attrs: { href: _vm.solicitud.anexo_uno, target: "_blank" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", id: "id-anexo" },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.datosBeca.label.anexo")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-descargar" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.solicitud.urlConvenio
        ? _c(
            "b-link",
            { attrs: { href: _vm.solicitud.urlConvenio, target: "_blank" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", id: "id-cab" },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.datosBeca.label.convenio")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-descargar" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSaving()
        ? _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save(_vm.form)
                },
              },
            },
            [
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("apeironGwApp.datosBeca.acciones.confirmarDatosBeca")
                  ),
                },
              }),
              _vm._v(" "),
              _c("b-icon", { attrs: { icon: "save" } }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }